import { termosStep } from '../../shared/termosSections';
import { juntadaSociedadeStep } from '../../shared/juntadaSections';

const pedidoJuntadaReconsideracaoSociedadeConfig = {
  id: 'pedido_juntada_reconsideracao_sociedade',
  nome: 'Pedido de Juntada de Reconsideração - Sociedade',
  descricao: 'Solicitação de juntada de reconsideração relativa à sociedade',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    documentosAdicionais: true,
    required: [
      { id: 'manifestacaoReconsideracao', tipoDocumentoProcesso: 490, name: 'Manifestação - Reconsideração', description: 'Documento contendo a manifestação da reconsideração', required: true }
    ]
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: '288',
    tiposAssunto: '838',
    tipoPedido: '488'
  },

  // Sem dadosRequerimentoConfig: só nome/documento de quem protocola e da
  // sociedade, sem endereço — nada mapeado em DadosRequerimento hoje.

  steps: [
    juntadaSociedadeStep(),
    termosStep()
  ]
};

export default pedidoJuntadaReconsideracaoSociedadeConfig;
